// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1fAZM","amount":"Amount_amount__2vC5w","tip":"Amount_tip__3Jj0F","tipHeader":"Amount_tipHeader__3u0Ut","tipsWrap":"Amount_tipsWrap__3W7fy"};